__webpack_require__.p = "https://dev3.development.tastelabgroup.com/";